export default __webpack_public_path__ + "static/media/dashboard_bottom_banner.a69944d4.png";